/* Der Schwarze Kapitän – Epilog "Seekarte": the whole journey on one chart (Wrapped-style recap, ab Di 1.12.).
   Self-contained module: reads window.KAPITAEN_DATEN (js/daten.js) and window.Spiel (js/spiel.js or js/dienst.js),
   no dependency on js/seite.js. Interface:
     KapitaenEpilog.render()        -> '<section id="seekarte" ...>' (HTML string)
     KapitaenEpilog.mount(section)  -> reveal observers, route drawing, ship marker (call after the string is in the DOM)
   Styles: css/epilog.css (all rules scoped under .kapitaen-lp). */
(function (global) {
  'use strict';
  var doc = global.document;

  /* ------------------------------------------------------------------ minimal helpers (copies of js/seite.js) */
  function D() { return global.KAPITAEN_DATEN; }
  function Sp() { return global.Spiel; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function A(p) { var m = global.KAPITAEN_ASSET_DATA; return (m && m[p]) || ('assets/' + p); }
  /* url() inside an inline custom property resolves against the stylesheet that uses it, so pass absolute URLs */
  function absUrl(u) { if (/^data:/.test(u)) return u; var a = doc.createElement('a'); a.href = u; return a.href; }
  function dat(s) { return String(s || '').replace(/\.20\d\d/g, '.'); }
  function pct(n) { return n + ' %'; }
  function fill(t, extra) {
    var sp = Sp(), l = sp.ladung(), vars = Object.assign({ PCT: sp.pct(l), LADUNG: l }, extra || {});
    return String(t == null ? '' : t).replace(/\{([A-Z_]+)\}/g, function (m, k) { return vars[k] !== undefined ? vars[k] : m; });
  }
  function reduziert() {
    var mq = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)');
    return !!(mq && mq.matches) || doc.documentElement.classList.contains('ruhig');
  }
  /* the first sentences of a text, up to roughly `max` characters (never cuts inside a sentence) */
  function saetze(t, max) {
    var s = String(t || '').split(/\n\n+/)[0].replace(/([.?!…«])\s+(?=[A-ZÄÖÜ»„])/g, '$1\u0000').split('\u0000'), out = s[0] || '';
    for (var i = 1; i < s.length && (out + ' ' + s[i]).length <= (max || 170); i++) out += ' ' + s[i];
    return out;
  }
  function summe(v) { return v ? Object.keys(v).reduce(function (s, k) { return s + (+v[k] || 0); }, 0) : 0; }

  /* ------------------------------------------------------------------ data */
  /* Auflösung text of the majority option (variants applied as in js/seite.js aufloesung()) */
  function aufloesungText(n) {
    var sp = Sp(), o = sp.option(n, sp.pfad(n)), t = o.aufloesung || '';
    (o.aufloesung_varianten || []).forEach(function (v) { if (sp.bedingung(v.wenn, { vor: n })) t = v.text; });
    (o.zusaetze || []).forEach(function (z) {
      if (!sp.bedingung(z.wenn, { vor: n })) return;
      if (z.ersetzt) t = t.replace(z.ersetzt, z.text);
      else if (z.nach && t.indexOf(z.nach) > -1) t = t.replace(z.nach, z.nach + ' ' + z.text);
    });
    return t;
  }
  function stimmeVon(n) { var e = Sp().etappe(n); return e.schiffsrat.aufloesung_stimme || (n <= 4 ? 'lloyd' : 'kapitaen'); }
  var STIMME = { lloyd: 'Captain Lloyd', kapitaen: 'Der Schwarze Kapitän', otto: 'Otto' };
  function beuteWort(p) { return p >= 15 ? 'Volle Beute' : (p >= 10 ? 'Halbe Beute' : 'Ottos Anteil'); }
  function station(nr) {
    var d = D(), s = d.onboarding.reise.stationen[nr - 1] || {}, k = d.kapitel && d.kapitel.stationen ? d.kapitel.stationen.filter(function (x) { return +x.nr === nr; })[0] : null;
    return { ort: (k && k.ort) || s.ort || '', datum: s.datum || '' };
  }

  /* Emmi's stage paintings (1000 × 500) + alt texts (same wording as js/seite.js ETAPPENBILD_ALT) */
  var ALT = {
    e1: 'Die Black Bean unter vollen Segeln im aufziehenden Sturm, am Großmast die schwarze Flagge.',
    e2: 'Der Kartenmacher in der Taverne auf Tortuga, bei Kerzenlicht über eine Seekarte gebeugt.',
    e3: 'Der Hafen von Nassau in der Sonne, am Kai ein Schiff mit roten Segeln.',
    e4: 'Ein Wrack mit zerrissenen Segeln zwischen Felsen im Nebel der Sargassosee.',
    e5: 'Otto, die Krake, taucht vor den Azoren auf und hebt eine Kiste vom Meeresgrund.',
    e6: 'Zwei Schiffe vor Saint-Malo: die Black Bean mit weißen Segeln, daneben ein Schiff mit roten Segeln.',
    e7: 'Die Black Bean bei Nacht im Nebel vor Dünkirchen, in der Ferne ein einzelnes Licht.',
    e8: 'Die Fischerbude unter den roten Klippen von Helgoland, draußen liegt die Black Bean.',
    steuermann: 'Die Black Bean bei Nacht vor Helgoland, unter Sternen auf Kurs nach Bremen.',
    signal: 'Morgengrauen am Fabrikenufer in Bremen: die Glocke am Kai, dahinter Speicher und die schwarze Flagge.',
    finale: 'Die Black Bean am Fabrikenufer, Otto hält mit einem Arm die schwarze Flagge über den Dächern.',
    bw: 'Das Fabrikenufer in Bremen, über dem Laden weht die schwarze Flagge.',
    glocke: 'Die Glocke am Kai des Fabrikenufers im ersten Licht.'
  };
  var BILD = { bw: 'klein/szenen/bw_fabrikenufer.webp', glocke: 'klein/szenen/k7_glocke_kai.webp' };
  function bild(key, cls) {
    var p = BILD[key] || ('etappen/' + key + '.webp'), w = BILD[key] ? 800 : 1000;
    return '<img class="' + (cls || 'sk-stop__img') + '" src="' + A(p) + '" alt="' + esc(ALT[key] || '') + '" width="' + w + '" height="' + (w / 2) + '" loading="lazy" decoding="async">';
  }

  /* ------------------------------------------------------------------ inline SVG */
  var SACK = function (voll) {
    return '<svg viewBox="0 0 48 56" aria-hidden="true" focusable="false" class="sk-sack' + (voll ? ' sk-sack--voll' : '') + '"><path d="M14 10c-2-3 1-6 4-4l3 2 3-3 3 3 3-2c3-2 6 1 4 4l-3 4c9 6 13 16 11 26-2 9-10 12-20 12S6 49 4 40C2 30 6 20 15 14z" class="sk-sack__k"/><path d="M15 14h18M17 34h14M19 39h10" class="sk-sack__n"/></svg>';
  };
  function saecke(l) { var h = ''; for (var i = 0; i < 6; i++) h += SACK(i < l); return '<span class="sk-saecke" role="img" aria-label="' + l + ' von 6 Säcken im Laderaum">' + h + '</span>'; }

  /* ---- chart: //lloyd-caffee.de/cdn/shop/t/10/assets/kapitaen-epilog-karte-canvas.webp?v=111503939430060616811792756132 (2000 × 1333, engraved parchment, no lettering).
     The nine stations are placed on this chart by eye (Jamaica, Tortuga off Hispaniola, Bahamas, Sargasso Sea,
     Azores, Brittany, Flemish coast, German Bight, Weser); js/seite.js ROUTE belongs to motive/karte-leer-hell.webp. ---- */
  var KARTE = 'epilog/karte-canvas.webp', KW = 2000, KH = 1333;
  var ROUTE = [[330, 812], [414, 770], [348, 690], [760, 610], [1140, 612], [1640, 420], [1702, 362], [1756, 292], [1796, 346]];
  var LABEL_OFF = [[0, 62, 'middle'], [34, 12, 'start'], [-34, -18, 'end'], [0, 64, 'middle'], [0, 64, 'middle'], [-34, 74, 'end'], [-30, 58, 'end'], [-34, -22, 'end'], [0, 66, 'middle']];
  function pfadD(pts) {
    var d = 'M' + pts[0][0] + ' ' + pts[0][1];
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      var c1 = [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6], c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
      d += ' C' + c1.map(Math.round).join(' ') + ' ' + c2.map(Math.round).join(' ') + ' ' + p2.join(' ');
    }
    return d;
  }
  function karte() {
    var d = pfadD(ROUTE);
    var punkte = ROUTE.map(function (p, i) {
      return '<g class="sk-kp" data-nr="' + (i + 1) + '" transform="translate(' + p[0] + ' ' + p[1] + ')"><circle r="22" class="sk-kp__siegel"/><circle r="16" class="sk-kp__ring"/></g>';
    }).join('');
    var labels = ROUTE.map(function (p, i) {
      var o = LABEL_OFF[i], nr = i + 1;
      return '<text class="sk-kl" data-nr="' + nr + '" x="' + (p[0] + o[0]) + '" y="' + (p[1] + o[1]) + '" text-anchor="' + o[2] + '">' + (nr === 9 ? 'B' : nr) + ' · ' + esc(station(nr).ort.replace(', Fabrikenufer', '')) + '</text>';
    }).join('');
    var namen = '<text class="sk-kn sk-kn--meer" x="1010" y="905" text-anchor="middle">Atlantik</text>' +
      '<g class="sk-kartusche"><text x="288" y="156" text-anchor="middle" class="sk-kartusche__h">Kurs Bremen</text></g>';
    return '<svg class="sk-karte__svg" viewBox="0 0 ' + KW + ' ' + KH + '" preserveAspectRatio="xMidYMid slice" role="img" aria-labelledby="sk-karte-titel"><title id="sk-karte-titel">Seekarte: die Route der Black Bean von Port Royal bis Bremen</title>' +
      '<image href="' + A(KARTE) + '" width="' + KW + '" height="' + KH + '"/>' + namen +
      '<path d="' + d + '" class="sk-route sk-route--plan"/><path d="' + d + '" class="sk-route sk-route--fahrt"/>' + punkte +
      '<g class="sk-schiff" transform="translate(' + ROUTE[0][0] + ' ' + ROUTE[0][1] + ')"><circle r="42" class="sk-schiff__glow"/><image href="' + A('logos/black-bean-signet-rund.webp') + '" x="-32" y="-32" width="64" height="64"/></g>' +
      '<g class="sk-labels">' + labels + '</g></svg>';
  }

  /* ------------------------------------------------------------------ cards */
  function balken(optionen, v) {
    var max = Math.max.apply(null, optionen.map(function (o) { return +v[o.key] || 0; }));
    return '<ul class="sk-rat" aria-label="So hat die Mannschaft abgestimmt">' + optionen.filter(function (o) { return (+v[o.key] || 0) > 0; }).map(function (o) {
      var p = +v[o.key] || 0, sieg = p === max;
      return '<li class="sk-rat__opt' + (sieg ? ' sk-rat__opt--sieg' : '') + '"><span class="sk-rat__name">' + esc(o.titel) + '</span><span class="sk-rat__balken" aria-hidden="true"><i style="--w:' + p + '%"></i></span><span class="sk-rat__pct">' + pct(p) + '</span></li>';
    }).join('') + '</ul>';
  }
  function stop(o) {
    /* o: { id, nr (map station), bild, kicker, ort, titel, text, stimme, rat, aufl, fuss } */
    return '<li class="sk-stop" id="sk-' + o.id + '" data-station="' + o.nr + '" data-pos="' + esc(o.pos) + '" data-ladung="' + o.ladung + '" data-wahl="' + esc(o.wahl) + '" data-beute="' + esc(o.beute || '') + '">' +
      '<article class="sk-stop__karte" aria-labelledby="sk-' + o.id + '-h">' +
      '<div class="sk-stop__bild">' + o.bild + '<span class="sk-siegel" aria-hidden="true">' + o.marke + '</span></div>' +
      '<div class="sk-stop__text">' +
      '<p class="sk-stop__kicker">' + esc(o.kicker) + '</p>' +
      '<h3 class="sk-stop__ort" id="sk-' + o.id + '-h">' + esc(o.ort) + '</h3>' +
      (o.titel ? '<p class="sk-stop__titel">' + esc(o.titel) + '</p>' : '') +
      (o.text ? '<p class="sk-stop__recap">' + esc(o.text) + '</p>' : '') +
      (o.rat || '') +
      (o.aufl ? '<blockquote class="sk-aufl"><p>' + esc(o.aufl) + '</p>' + (o.stimme ? '<footer>' + esc(o.stimme) + '</footer>' : '') + '</blockquote>' : '') +
      (o.fuss ? '<div class="sk-stop__fuss">' + o.fuss + '</div>' : '') +
      '</div></article></li>';
  }
  function etappenStop(n) {
    var sp = Sp(), e = sp.etappe(n), key = sp.pfad(n), o = sp.option(n, key), v = sp.verteilung(n), l = sp.ladungNach(n);
    var rat = '<div class="sk-ratblock"><p class="sk-label">Schiffsrat · ' + esc(e.schiffsrat.titel) + '</p>' +
      (summe(v) ? balken(e.schiffsrat.optionen, v) : '<p class="sk-rat__nur">Die Mannschaft hat entschieden: <strong>' + esc(o.titel) + '</strong></p>') + '</div>';
    var beute = '<span class="sk-chip sk-chip--b' + o.beute_pct + '">' + beuteWort(o.beute_pct) + ' · ' + pct(o.beute_pct) + '</span>' +
      (o.sack ? '<span class="sk-chip sk-chip--sack">+1 Sack</span>' : '') + (o.sack_verlust ? '<span class="sk-chip sk-chip--verlust">−1 Sack</span>' : '');
    return stop({
      id: 'e' + n, nr: n, marke: String(n), bild: bild('e' + n),
      kicker: 'Etappe ' + n + ' · ' + dat(e.datum), ort: e.ort, titel: e.titel, text: e.teaser,
      pos: 'Etappe ' + n + ' · ' + e.ort, ladung: l, wahl: o.titel, beute: beuteWort(o.beute_pct) + ' · ' + pct(o.beute_pct),
      rat: rat, aufl: saetze(aufloesungText(n), 170), stimme: STIMME[stimmeVon(n)],
      fuss: '<div class="sk-beute">' + beute + '</div><div class="sk-laderaum"><span class="sk-label">Laderaum</span>' + saecke(l) + '</div>'
    });
  }
  function steuermannStop() {
    var sp = Sp(), s = D().steuermann, l = sp.ladungNach(8);
    return stop({
      id: 'steuermann', nr: 8, marke: '8½', bild: bild('steuermann'),
      kicker: 'Nachtrag · ' + dat(s.datum) + ', 20 Uhr', ort: 'Helgoland, Reede', titel: s.titel,
      pos: 'Steuermann-Abend · Helgoland', ladung: l, wahl: 'Anteil einen Abend früher', beute: 'Steuerleute · ' + pct(sp.pct(l)),
      aufl: saetze(s.text_absaetze[0], 160), stimme: STIMME.kapitaen,
      fuss: '<div class="sk-beute"><span class="sk-chip sk-chip--b15">Steuerleute · ' + pct(sp.pct(l)) + ' auf alles</span></div><p class="sk-fussnote">Einen Abend früher, für alle ab 17 Bohnen im Seesack.</p>'
    });
  }
  function blackWeekStop() {
    var sp = Sp(), bw = D().black_week || [];
    if (!bw.length) return '';
    var tage = '<ol class="sk-tage" aria-label="Sechs Tage, sechs Regale">' + bw.map(function (b) {
      return '<li><span class="sk-tage__tag">' + esc(String(b.datum).slice(0, 2)) + '</span><span class="sk-tage__auf">' + esc(String(b.auf).split(' (')[0].replace(' außer Gutscheine', '')) + '</span></li>';
    }).join('') + '</ol>';
    return stop({
      id: 'blackweek', nr: 9, marke: '⚑', bild: bild('bw'),
      kicker: 'Black Week · ' + dat(bw[0].datum).slice(3) + '–' + dat(bw[bw.length - 1].datum).slice(3), ort: 'Gekapert', titel: 'Bremen, Fabrikenufer',
      pos: 'Black Week · Fabrikenufer', ladung: sp.ladung(), wahl: 'Jeden Tag ein Regal', beute: 'Tagesbeute · ' + pct(sp.pct()),
      aufl: bw[0].headline, stimme: STIMME.kapitaen, rat: tage,
      fuss: '<div class="sk-beute"><span class="sk-chip sk-chip--b' + sp.pct() + '">Tagesbeute · ' + pct(sp.pct()) + '</span></div>'
    });
  }
  function signalStop() {
    var sp = Sp(), sg = D().signal, ab = sg.abstimmung, v = sp.signalVerteilung();
    var rat = '<div class="sk-ratblock"><p class="sk-label">Gemeinsame Abstimmung · ' + esc(ab.frage) + '</p>' + (summe(v) ? balken(ab.optionen, v) : '') + '</div>';
    return stop({
      id: 'signal', nr: 9, marke: '◉', bild: bild('signal'),
      kicker: sg.untertitel + ' · ' + dat(sg.datum) + ' · Erster Advent', ort: sg.titel, titel: null,
      pos: 'Das Signal · Fabrikenufer', ladung: sp.ladung(), wahl: sp.ausgang() === 'BLEIBEN' ? 'An Bord geblieben' : 'Übergelaufen', beute: summe(v) ? pct(sp.ausgang() === 'BLEIBEN' ? v.bleiben : v.ueberlaufen) + ' der Mannschaft' : '',
      aufl: saetze(sg.brief_lloyd[2], 120), stimme: STIMME.lloyd, rat: rat
    });
  }
  function finaleStop() {
    var sp = Sp(), f = D().finale, v = sp.signalVerteilung(), a = sp.ausgang(), aus = f.ausgang && f.ausgang[a];
    return stop({
      id: 'finale', nr: 9, marke: '⌂', bild: bild('glocke'),
      kicker: 'Finale · ' + dat(f.datum), ort: f.titel, titel: 'Bremen, Fabrikenufer · ' + f.untertitel,
      pos: 'Finale · Fabrikenufer', ladung: sp.ladung(), wahl: 'Zurückerobert', beute: 'Der Laden ist wieder hell',
      aufl: aus ? saetze(fill(aus.text, { ANTEIL_A: v.ueberlaufen, ANTEIL_B: v.bleiben }), 150) : '', stimme: STIMME.lloyd,
      fuss: '<p class="sk-fussnote sk-fussnote--satz">»Moin, Hinnerk. Nimm die Mütze ab.«</p>'
    });
  }

  /* ------------------------------------------------------------------ Wrapped tiles */
  function zahlen() {
    var sp = Sp(), d = D(), voll = 0, knapp = null, mit = 0, abgestimmt = 0, eigene = sp.stand.stimmen || {};
    for (var n = 1; n <= 8; n++) {
      var key = sp.pfad(n), o = sp.option(n, key), v = sp.verteilung(n);
      if (o.beute_pct >= 15) voll++;
      if (summe(v) && (!knapp || v[key] < knapp.p)) knapp = { n: n, p: v[key], titel: o.titel };
      if (eigene[n]) { abgestimmt++; if (eigene[n] === key) mit++; }
    }
    var sv = sp.signalVerteilung(), ausgang = sp.ausgang(), l = sp.ladung();
    if (sp.stand.signal) { abgestimmt++; if ((sp.stand.signal === 'bleiben') === (ausgang === 'BLEIBEN')) mit++; }
    var nach = d.finale.epilog_nachher && d.finale.epilog_nachher.text;
    var t = [];
    t.push('<li class="sk-z sk-z--bild"><figure>' + bild('finale', 'sk-z__img') + '<figcaption><span class="sk-z__kicker">' + esc(d.finale.untertitel) + ' · ' + dat(d.finale.datum) + '</span><strong>' + esc(d.finale.titel) + '</strong>' + (nach ? '<span class="sk-z__zitat">»' + esc(nach) + '«<em>Captain Lloyd</em></span>' : '') + '</figcaption></figure></li>');
    t.push('<li class="sk-z"><span class="sk-z__kicker">Etappen</span><span class="sk-z__zahl">8</span><span class="sk-z__text">Etappen von Port Royal bis Helgoland, dann sechs Tage gekapert in Bremen.</span></li>');
    t.push('<li class="sk-z"><span class="sk-z__kicker">Schiffsrat</span><span class="sk-z__zahl">9</span><span class="sk-z__text">Abstimmungen im Schiffsrat, das Signal mitgezählt.</span></li>');
    t.push('<li class="sk-z"><span class="sk-z__kicker">Volle Beute</span><span class="sk-z__zahl">' + voll + '<small>×</small></span><span class="sk-z__text">volle Beute rausgeholt. ' + (voll >= 5 ? 'Das kann sich sehen lassen.' : 'Otto hat gut mitverdient.') + '</span></li>');
    t.push('<li class="sk-z sk-z--laderaum"><span class="sk-z__kicker">Laderaum</span><span class="sk-z__zahl">' + l + '<small>/6</small></span>' + saecke(l) + '<span class="sk-z__text">Säcke im Laderaum, als die Black Bean in Bremen festmachte. Macht ' + pct(sp.pct(l)) + ' Beute in der Black Week.</span></li>');
    if (knapp) t.push('<li class="sk-z"><span class="sk-z__kicker">Knappste Entscheidung</span><span class="sk-z__zahl">' + pct(knapp.p) + '</span><span class="sk-z__text">' + esc(sp.etappe(knapp.n).ort) + ': »' + esc(knapp.titel) + '«. Knapp, aber Mehrheit ist Mehrheit.</span></li>');
    if (summe(sv)) {
      var ueber = ausgang !== 'BLEIBEN';
      t.push('<li class="sk-z sk-z--ausgang"><span class="sk-z__kicker">Das Signal</span><span class="sk-z__zahl">' + pct(ueber ? sv.ueberlaufen : sv.bleiben) + '</span><span class="sk-z__text">' + (ueber ? 'sind übergelaufen, als die Glocke schlug. Der Laden ist zurückerobert.' : 'sind an Bord geblieben. Den Laden hat Lloyd trotzdem zurückgeholt.') + '</span></li>');
    }
    if (abgestimmt) t.push('<li class="sk-z sk-z--ich"><span class="sk-z__kicker">Eure Stimme</span><span class="sk-z__zahl">' + mit + '<small>/' + abgestimmt + '</small></span><span class="sk-z__text">Mal lag eure Stimme bei der Mehrheit.</span></li>');
    if (sp.stand.token && sp.bohnen() > 0) t.push('<li class="sk-z sk-z--ich"><span class="sk-z__kicker">Seesack</span><span class="sk-z__zahl">' + sp.bohnen() + '<small>/24</small></span><span class="sk-z__text">Bohnen für richtige Antworten.' + (sp.bohnen() >= 17 ? ' Steuermann-Klasse.' : '') + '</span></li>');
    /* close the grid: 4 columns (wide) with the picture tile taking 4 cells; the last tile spans the gap */
    var k = t.length - 1, r4 = (4 + k) % 4, r3 = (4 + k) % 3, r2 = k % 2;
    t[k] = t[k].replace('<li class="sk-z', '<li style="--sk-s4:' + (r4 ? 5 - r4 : 1) + ';--sk-s3:' + (r3 ? 4 - r3 : 1) + ';--sk-s2:' + (r2 ? 2 : 1) + '" class="sk-z sk-z--rest');
    return '<div class="sk-zahlen"><div class="sk-zahlen__kopf"><p class="sk-kicker">Eure Reise in Zahlen</p><h2 class="sk-zahlen__h">Vier Wochen, auf den Punkt.</h2></div><ul class="sk-zahlen__raster">' + t.join('') + '</ul></div>';
  }

  /* timetable of all stops in the header (anchor links to the cards) */
  function fahrplan() {
    var li = [];
    for (var n = 1; n <= 8; n++) { var e = Sp().etappe(n); li.push([n, e.ort, dat(e.datum).slice(3), 'e' + n]); }
    li.push(['8½', 'Steuermann', '22.11.', 'steuermann'], ['⚑', 'Gekapert', '23.–28.11.', 'blackweek'], ['◉', 'Das Signal', '29.11.', 'signal'], ['⌂', 'Rückeroberung', '30.11.', 'finale']);
    return '<nav class="sk-fahrplan" aria-label="Stationen der Reise"><p class="sk-label">Fahrplan</p><ol>' + li.map(function (x) {
      return '<li><a href="#sk-' + x[3] + '"><span class="sk-fahrplan__nr" aria-hidden="true">' + x[0] + '</span><span class="sk-fahrplan__ort">' + esc(x[1]) + '</span><span class="sk-fahrplan__dat">' + esc(x[2]) + '</span></a></li>';
    }).join('') + '</ol></nav>';
  }
  /* log strip under the sticky chart (wide screens): position, hold, decision of the card in view */
  function hud() {
    return '<div class="sk-hud" aria-hidden="true"><div class="sk-hud__feld sk-hud__feld--pos"><span class="sk-label">Position</span><strong class="sk-hud__pos">Port Royal</strong></div>' +
      '<div class="sk-hud__feld"><span class="sk-label">Laderaum</span>' + saecke(0).replace(' role="img" aria-label="0 von 6 Säcken im Laderaum"', '') + '</div>' +
      '<div class="sk-hud__feld"><span class="sk-label">Entscheidung</span><strong class="sk-hud__wahl">–</strong><span class="sk-hud__beute"></span></div></div>';
  }

  /* ------------------------------------------------------------------ render */
  function render() {
    var d = D(), sp = Sp();
    if (!d || !sp) return '';
    var stops = [];
    for (var n = 1; n <= 8; n++) stops.push(etappenStop(n));
    stops.push(steuermannStop(), blackWeekStop(), signalStop(), finaleStop());
    return '<section id="seekarte" class="sektion seekarte" aria-labelledby="sk-titel" style="--sk-karte:url(' + absUrl(A(KARTE)) + ')">' +
      '<div class="sk-rahmen">' +
      '<header class="sk-kopf"><div class="sk-kopf__text"><p class="sk-kicker">Die Seekarte · 30. Oktober bis 30. November</p><h2 id="sk-titel" class="sk-h2">Die ganze Reise auf einer Karte.</h2>' +
      '<p class="sk-unter">Acht Etappen, eine Woche gekapert, ein Signal. Hier steht, wie die Mannschaft abgestimmt hat und was daraus geworden ist. Die Karte bleibt hängen.</p></div>' +
      fahrplan() + '</header>' +
      '<div class="sk-buehne">' +
      '<div class="sk-karte"><div class="sk-karte__rahmen">' + karte() + '</div>' + hud() + '</div>' +
      '<ol class="sk-liste">' + stops.join('') + '</ol>' +
      '</div>' + zahlen() + '</div></section>';
  }

  /* ------------------------------------------------------------------ mount: reveal, route drawing, ship */
  function mount(sec) {
    sec = sec || doc.getElementById('seekarte');
    if (!sec || sec.__skMount) return;
    sec.__skMount = true;
    var svg = sec.querySelector('.sk-karte__svg'), fahrt = sec.querySelector('.sk-route--fahrt'), schiff = sec.querySelector('.sk-schiff');
    var kartenBox = sec.querySelector('.sk-karte'), hudPos = sec.querySelector('.sk-hud__pos'), hudWahl = sec.querySelector('.sk-hud__wahl'), hudBeute = sec.querySelector('.sk-hud__beute'), hudSaecke = [].slice.call(sec.querySelectorAll('.sk-hud .sk-sack'));
    var stops = [].slice.call(sec.querySelectorAll('.sk-stop')), kacheln = [].slice.call(sec.querySelectorAll('.sk-z'));
    var punkte = [].slice.call(sec.querySelectorAll('.sk-kp')), labels = [].slice.call(sec.querySelectorAll('.sk-kl'));
    var ruhig = reduziert();

    /* --sk-ks = screen px per SVG unit; labels keep a 14px minimum on screen */
    function skala() { var vb = svg.viewBox.baseVal, w = svg.clientWidth, h = svg.clientHeight; if (vb && vb.width && w) svg.style.setProperty('--sk-ks', Math.max(w / vb.width, h / vb.height).toFixed(4)); }
    skala();
    if (global.ResizeObserver) new global.ResizeObserver(skala).observe(svg);

    var len = fahrt.getTotalLength(), stationLen = [0], step = len / 900, sIdx = 1;
    for (var t = 0; t <= len && sIdx < ROUTE.length; t += step) {
      var pt = fahrt.getPointAtLength(t), r = ROUTE[sIdx];
      if (Math.hypot(pt.x - r[0], pt.y - r[1]) < 5) { stationLen[sIdx] = t; sIdx++; }
    }
    while (stationLen.length < ROUTE.length) stationLen.push(len);
    fahrt.style.strokeDasharray = len + ' ' + len;

    var aktuell = 0, ziel = 0, rafId = 0, aktivNr = 0;
    function zeichne(l) {
      fahrt.style.strokeDashoffset = (len - l).toFixed(1);
      var a = fahrt.getPointAtLength(Math.max(0.1, l)), b = fahrt.getPointAtLength(Math.max(0, l - 6));
      var dx = a.x - b.x, dy = a.y - b.y, n = Math.hypot(dx, dy) || 1, off = l < 1 ? 0 : 46;
      schiff.setAttribute('transform', 'translate(' + (a.x - dy / n * off).toFixed(1) + ' ' + (a.y + dx / n * off).toFixed(1) + ')');
      punkte.forEach(function (p, i) { p.classList.toggle('sk-kp--erreicht', stationLen[i] <= l + 2); });
    }
    function fahre(nachL, dauer) {
      ziel = nachL;
      if (ruhig) { aktuell = ziel; zeichne(aktuell); return; }
      cancelAnimationFrame(rafId);
      var von = aktuell, t0 = null, ms = dauer || Math.min(1600, 500 + Math.abs(ziel - von) * 1.2);
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var q = Math.min(1, (ts - t0) / ms), e = 1 - Math.pow(1 - q, 3);
        aktuell = von + (ziel - von) * e; zeichne(aktuell);
        if (q < 1) rafId = requestAnimationFrame(tick);
      }
      rafId = requestAnimationFrame(tick);
    }
    function markiere(nr, stopEl) {
      if (nr === aktivNr && stopEl && stopEl.classList.contains('sk-stop--aktiv')) return;
      aktivNr = nr;
      stops.forEach(function (s) { s.classList.toggle('sk-stop--aktiv', s === stopEl); });
      punkte.forEach(function (p) { p.classList.toggle('sk-kp--aktuell', +p.getAttribute('data-nr') === nr); });
      labels.forEach(function (p) { p.classList.toggle('sk-kl--aktuell', +p.getAttribute('data-nr') === nr); });
      if (hudPos) {
        hudPos.textContent = stopEl ? stopEl.getAttribute('data-pos') : 'Bremen, Fabrikenufer';
        hudWahl.textContent = (stopEl && stopEl.getAttribute('data-wahl')) || 'Zurückerobert';
        hudBeute.textContent = (stopEl && stopEl.getAttribute('data-beute')) || '';
        var l = stopEl ? +stopEl.getAttribute('data-ladung') : Sp().ladung();
        hudSaecke.forEach(function (x, i) { x.classList.toggle('sk-sack--voll', i < l); });
      }
    }

    var kein_io = !('IntersectionObserver' in global);
    if (ruhig || kein_io) {
      sec.classList.add('sk-ruhig');
      zeichne(len); markiere(9, null);
      return;
    }
    sec.classList.add('sk-bewegt');
    zeichne(0);

    /* reveal: cards and tiles slide in once */
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sk-da'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    stops.concat(kacheln).forEach(function (el) { io.observe(el); });

    /* sticky chart (wide screens): the route follows the card in the middle of the viewport.
       Stacked chart (phones): the route draws once when the chart comes into view. */
    function sticky() { return global.getComputedStyle(kartenBox).position === 'sticky'; }
    var gezeichnet = false;
    var kio = new IntersectionObserver(function (list) {
      if (list[0].isIntersecting && !sticky() && !gezeichnet) { gezeichnet = true; markiere(9, null); fahre(len, 2800); }
    }, { threshold: 0.35 });
    kio.observe(kartenBox);

    var geplant = false;
    function pruefe() {
      geplant = false;
      if (!sticky()) return;
      var vh = global.innerHeight, mitte = vh * 0.5, treffer = null;
      for (var i = 0; i < stops.length; i++) { var r = stops[i].getBoundingClientRect(); if (r.top < mitte) treffer = stops[i]; }
      var nr = treffer ? +treffer.getAttribute('data-station') : 1;
      var zielL = treffer ? stationLen[nr - 1] : 0;
      /* past the last card (Wrapped tiles): the whole route, ship in Bremen */
      var liste = sec.querySelector('.sk-liste').getBoundingClientRect();
      if (liste.bottom < mitte) { zielL = len; nr = 9; }
      markiere(nr, treffer || stops[0]);
      if (Math.abs(zielL - ziel) > 0.5) fahre(zielL);
    }
    function plane() { if (!geplant) { geplant = true; requestAnimationFrame(pruefe); } }
    global.addEventListener('scroll', plane, { passive: true });
    global.addEventListener('resize', plane);
    plane();
  }

  global.KapitaenEpilog = { render: render, mount: mount };
})(window);
